import { MRT_ColumnDef } from 'material-react-table';
import { EmployeeDTO } from 'probonio-shared-ui/api';
import { useMemo } from 'react';
import { AdditionalEmployeeColumns } from '../employeeStatusList/EmployeeBenefitStatusList';

export function useAdditionalBikeleasingColumns(): AdditionalEmployeeColumns {
  return useMemo(() => {
    const columns: MRT_ColumnDef<EmployeeDTO>[] = [
      {
        accessorKey: 'bikeleasingEmployeeCode',
        id: 'bikeleasingUserId',
        header: 'Bikeleasing User ID',
        enableSorting: false,
      },
    ];
    return { columns };
  }, []);
}
